import styled from 'styled-components';
import { ThemeProps } from '@/styles/global';

export const Container = styled.a`
  cursor: pointer;
  display: flex;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 4px rgba(89, 115, 114, 0.16);
  &:not(last-child) {
    margin-bottom: 2.5rem;
  }
  &:hover {
    box-shadow: 0 0 0.25rem rgb(16 168 35 / 50%);
  }
  @media (max-width: 678px) {
    display: block;
    &:not(last-child) {
      margin-bottom: 1.5rem;
    }
  }
`;

export const ImageContainer = styled.div`
  width: 47%;
  cursor: pointer;
  border-radius: 0.25rem;
  overflow: hidden;
  max-height: 20rem;
  @media (max-width: 678px) {
    width: 100%;
  }
`;

export const PreviewImg = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  transition: 0.2s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;

export const StyledTechDiv = styled.div`
  background: rgba(16, 168, 35, 0.13);
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem;
  color: ${(props: ThemeProps) => props.theme.softGreenColor};
  font-size: 0.9rem;
  line-height: 1.3rem;
  width: fit-content;
`;

export const InfoContainer = styled.div`
  padding: 1.5rem;
  width: 53%;
  @media (max-width: 678px) {
    padding: 1rem;
    width: 100%;
  }
`;

export const Title = styled.p`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  margin-bottom: 1rem;
  @media (max-width: 678px) {
    font-size: 1rem;
    font-weight: 500;
    margin: 1rem 0;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.5rem;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  margin-bottom: 1rem;
`;

export const User = styled.div`
  display: flex;
  justify-content: space-between;
  p {
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.3rem;
    color: ${(props: ThemeProps) => props.theme.darkGrayColor};
    margin: 0;
    display: flex;
    svg {
      display: block;
      margin-right: 0.5rem;
    }
  }
`;
